import React from 'react';
import styles from './Resource.module.css';
import support from "./icons/support.svg";
import FAQ from "./icons/FAQ.svg";
import Location from "./icons/location.svg";
import Settins from "./icons/settings.svg"
import Knowledge from "./icons/knowlege.svg"
import guide from "./icons/guide.svg"
import email from "./icons/mail.svg"
import { links } from 'HelpLinks';
const resourceData = [
    {
        image: guide,
        title: "User guide",
        description: "Step-by-step instructions and tutorials to help you navigate and utilize our software effectively.",
        link:links.userGuide
    },
    {
        image: Knowledge,
        title: "Knowledge Base",
        description: "A comprehensive collection of articles, guides, and resources to help you troubleshoot and get the most out of our software.",
        link:links.knowledgeBase
    },
    {
        image: FAQ,
        title: "FAQ",
        description: "We provide a comprehensive collection of frequently asked questions covering Agent Enrollment, Inventory, Security, Pricing, and other topics.",
        link:links.faq
    },
    {
        image: Settins,
        title: "System Requirements",
        description: "Review technical specifications for agent OS, technician machine, and supported browser for optimal performance.",
        link:links.sysReq
    },
    {
        image: support,
        title: "Demo Request",
        description: "Request a personalized product demo to explore features tailored to your organization’s needs.",
        link:links.demoReq
    },
    {
        image: email,
        title: "Contact Support",
        description: "Need help? Reach out to our support team for quick assistance with any product-related issues.",
        link:links.support
    },

    /*
    {
        image: Location,
        title: "Product Roadmap",
        description: "Share your ideas and help us prioritize upcoming features. Provide feedback on how specific features can make a meaningful impact.",
        link:""
    },
    {
        image: support,
        title: "Free Training",
        description: "Join our complimentary training to delve into each feature in depth and have all your questions addressed. Also, you can view our past training sessions.",
        link:""
    }
    */
];

function Resource({ data }) {
    return (
        <div className={styles.container}>
            <h3 className={styles.heading}>Explore useful features</h3>
            <p className={styles.tagLine}>
                Here is your quick guide. Learn how to use its features and modules in depth.
            </p>
            <div className={styles.gridContainer}>
                {data.map((item, index) => (
                    <div key={index} className={styles.card}>
                        {item.image && <img src={item.image} alt={item.title} className={styles.icon} />}
                        <h4 className={styles.title}>{item.title}</h4>
                        <p className={styles.description}>{item.description}</p>
                        <a href={item.link} target="_blank" rel="noreferrer">
                            <p className={styles.learMore}>Learn more</p>
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default function App() {
    return <Resource data={resourceData} />;
}
